class Modals {
	init() {
		const body = document.querySelector('body') as HTMLElement;
		const bound = new WeakSet<HTMLElement>();

		const addClickListener = (el: HTMLElement) => {
			if (bound.has(el)) {
				return;
			}
			bound.add(el);

			el.addEventListener('click', () => {
				if (body.classList.contains('modal-open')) {
					body.classList.remove('modal-open');
				} else {
					body.classList.add('modal-open');
				}
			});
		};

		// Apply event listener to existing elements
		const modalToggle = document.querySelectorAll(
			'[aria-controls="consultation-modal"]'
		) as NodeListOf<HTMLElement>;
		modalToggle.forEach(addClickListener);

		// Create a MutationObserver to watch for new elements being added to the DOM
		const observer = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'childList') {
					mutation.addedNodes.forEach((node) => {
						if (node instanceof HTMLElement) {
							if (node.matches('[aria-controls="consultation-modal"]')) {
								addClickListener(node);
							}

							// Also check for any matching descendants
							const descendants = node.querySelectorAll(
								'[aria-controls="consultation-modal"]'
							);
							descendants.forEach((descendant) => {
								if (descendant instanceof HTMLElement) {
									addClickListener(descendant);
								}
							});
						}
					});
				}
			});
		});

		// Start observing the document body for changes
		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}
}

export default new Modals();
